!(function() {
	const burger = document.getElementById("burger");
	const mobileMenu = document.getElementById("mobile-menu");
	const body = document.body;
	const closeMenu = document.getElementById("close-menu");
	const servicesBtn = document.getElementById("mobile-services");
	const servicesMenu = document.getElementById("mobile-services-menu");
	const goBackBtn = document.getElementById("previous-menu");

	burger.addEventListener("click", function() {
		
		mobileMenu.classList.add("is-active");
		body.classList.add("overflow-hidden");
	});

	closeMenu.addEventListener("click", function() {
		
		mobileMenu.classList.remove("is-active");
		body.classList.remove("overflow-hidden");
	});

	servicesBtn.addEventListener("click", function() {
		servicesMenu.classList.add("is-active");
	});
	
	goBackBtn.addEventListener("click", function() {
		servicesMenu.classList.remove("is-active");
	});

})()